export class Task {
    name;
    run;
    mode;
    constructor(name, run, mode) {
        this.name = name;
        this.run = run;
        this.mode = mode;
    }
}
